/**
 * PDP Talking rice treats UGC — play/pause, horizontal scroll, prev/next nav.
 * Used by sections/pb-pdp-talking-rice-treats.liquid only.
 */
(function () {
  function scrollByCard(scroller, direction) {
    if (!scroller) return;
    const card = scroller.querySelector('[data-pb-pdp-tb-slide]:not([data-pb-pdp-tb-clone-start]):not([data-pb-pdp-tb-clone-end])')
      || scroller.querySelector('[data-pb-pdp-tb-slide]');
    if (!card) return;
    const styles = window.getComputedStyle(scroller);
    const gap = parseFloat(styles.columnGap || styles.gap) || 16;
    const delta = (card.getBoundingClientRect().width + gap) * direction;
    scroller.scrollBy({ left: delta, behavior: 'smooth' });
  }

  function initTalkingUgc(ugc) {
    if (!ugc || ugc.dataset.pbTalkingUgcMounted === '1') return;
    ugc.dataset.pbTalkingUgcMounted = '1';

    const slides = ugc.querySelectorAll('[data-pb-pdp-tb-slide]');
    const carousel = ugc.closest('.pb-pdp-tb__carousel');
    const prevBtn = carousel?.querySelector('[data-pb-pdp-tb-prev]');
    const nextBtn = carousel?.querySelector('[data-pb-pdp-tb-next]');

    prevBtn?.addEventListener('click', () => scrollByCard(ugc, -1));
    nextBtn?.addEventListener('click', () => scrollByCard(ugc, 1));

    function pauseOthers(exceptSlide) {
      slides.forEach((slide) => {
        if (slide === exceptSlide) return;
        const player = slide.querySelector('[data-pb-pdp-tb-player]');
        if (!player) return;
        player.pause();
        player.currentTime = 0;
        slide.classList.remove('is-playing');
        const trigger = slide.querySelector('[data-pb-pdp-tb-trigger]');
        if (trigger) {
          trigger.setAttribute('aria-label', trigger.getAttribute('data-pb-aria-play') || 'Play video');
        }
      });
    }

    slides.forEach((slide) => {
      const trigger = slide.querySelector('[data-pb-pdp-tb-trigger]');
      const player = slide.querySelector('[data-pb-pdp-tb-player]');
      if (!trigger) return;

      const playLabel = trigger.getAttribute('data-pb-aria-play') || 'Play video';
      const pauseLabel = trigger.getAttribute('data-pb-aria-pause') || 'Pause video';

      trigger.addEventListener('click', () => {
        const externalHref = trigger.getAttribute('data-pb-pdp-tb-href');

        if (!player) {
          if (externalHref) window.open(externalHref, '_blank', 'noopener,noreferrer');
          return;
        }

        if (slide.classList.contains('is-playing')) {
          player.pause();
          slide.classList.remove('is-playing');
          trigger.setAttribute('aria-label', playLabel);
          return;
        }

        pauseOthers(slide);
        slide.classList.add('is-playing');
        player.play().catch(() => {
          slide.classList.remove('is-playing');
          trigger.setAttribute('aria-label', playLabel);
          if (externalHref) window.open(externalHref, '_blank', 'noopener,noreferrer');
        });
        trigger.setAttribute('aria-label', pauseLabel);
      });

      player?.addEventListener('ended', () => {
        slide.classList.remove('is-playing');
        trigger.setAttribute('aria-label', playLabel);
      });
    });

    if (slides.length > 1 && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) return;
            const slide = entry.target;
            const player = slide.querySelector('[data-pb-pdp-tb-player]');
            if (!player || player.paused) return;
            player.pause();
            player.currentTime = 0;
            slide.classList.remove('is-playing');
            const trigger = slide.querySelector('[data-pb-pdp-tb-trigger]');
            trigger?.setAttribute('aria-label', trigger.getAttribute('data-pb-aria-play') || 'Play video');
          });
        },
        { threshold: 0.2 }
      );
      slides.forEach((slide) => io.observe(slide));
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (window.matchMedia('(min-width: 750px)').matches) return;
        const firstSlide = ugc.querySelector('[data-pb-pdp-tb-slide]');
        const cloneStart = ugc.querySelector('[data-pb-pdp-tb-clone-start]');
        if (!firstSlide || !cloneStart) return;
        const slideLeft = firstSlide.getBoundingClientRect().left;
        const scrollerLeft = ugc.getBoundingClientRect().left;
        const centerOffset = (ugc.clientWidth - firstSlide.offsetWidth) / 2;
        ugc.scrollLeft += slideLeft - scrollerLeft - centerOffset;
      });
    });
  }

  document.querySelectorAll('[data-pb-pdp-talking-ugc]').forEach(initTalkingUgc);
})();
